import React from "react";
import { Box, Card, CardActions, CardContent, CardMedia, Grid, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import { Hit } from "react-instantsearch-core";
import { DateTime } from "luxon";
import useMediaQuery from "@mui/material/useMediaQuery";

// import TopicChips from "./topic-chips";
import CategoryLabel from "./CategoryLabel";
import CategoryIcon from "./CategoryIcon";

const CARD_IMAGE_HEIGHT = "163px";

const useStyles = makeStyles((theme) => ({
  card: {
    outlineWidth: "2px",
    outlineOffset: "2px",
    height: "100%",
    cursor: "pointer",
  },
  link: {
    textDecoration: "none",
    height: "100%",
    display: "block",
    transition: "transform .2s ease-in-out",
    "&:hover": {
      transform: "scale(1.02)",
      textDecoration: "none",
    },
    "&:focus": {
      transform: "scale(1.02)",
      textDecoration: "none",
    },
  },
  // img: {
  //   height: "100%",
  //   maxHeight: "242px",
  //   objectFit: "cover",
  // },
}));

type CustomHitProps = {
  types?: string[];
  create_date: number;
};

type CustomHit = Hit & CustomHitProps;

interface HitProps {
  hit: CustomHit;
  children?: JSX.Element;
  className?: string;
  headingLevel?: "h2" | "h3" | "h4";
}

// const shortenText = (str: string, len: number): string => {
//   let retval = str.substr(0, len + str.substr(len).indexOf(" "));
//   return `${retval.trim()}…`;
// };

const HitCard: React.FunctionComponent<any> = (props): JSX.Element => {
  const classes = useStyles();
  const { hit, headingLevel = "h3" }: HitProps = props;
  const rowBreakpoint: boolean = useMediaQuery<any>((theme) => theme.breakpoints.up("sm"));

  // const followLink = (url: string) => {
  //   window.location.assign(url);
  // };

  //new icon class
  let iconClassName = '';
  if (hit.new_icon) {
    iconClassName = ' new-icon';
  }

  const dt = DateTime.fromMillis(hit.create_date);
  const articles = ["Forskning", "Nyheter", "Så gör andra"];
  const isArticle = hit.types && Array.isArray(hit.types) && hit.types.length ? articles.indexOf(hit.types[0]) > -1 : false;
  // const mediaHeight = "150px";

  return (

<a className="maincard maincard-article maincard-article-horizontal" href={hit.url} tabIndex={0}>
{hit.image_url.length > 0 ? (
  <div className="maincard-image">
    <img src={hit.image_url} alt={hit.image_caption} />
    {hit.new_icon && (
      <div className="maincard-new">NY</div>
    )}
    {hit.types && hit.types.length > 0 && (
      <div className="maincard-article-label">
        <span className="body-3 bold">{hit.types}</span>
      </div>
    )}
  </div>
) : (
  <div className="maincard-image no-image"></div>
)}

<div className="maincard-content content-is-article">
  <div>
    <h3 className="h4">{hit.title}</h3>
  </div>
  <p>{hit.content_short}</p>

  {hit.categories && Array.isArray(hit.categories) &&
    <div className="maincard-article-meta content-filtering-meta">
      {hit.categories.map((category: string, i: number) => {
        return (
          <>
            <p className="body-3"><b>{category}</b></p>
            <div className="divider"></div>
          </>
        )
      })}

      {isArticle && (
        <>
          <p className="body-3"><b>{dt.setLocale("sv").toISODate()}</b></p>
        </>
      )}
    </div>
  }
</div>
</a>
  );
};

export default HitCard;
